import { Component, OnInit, OnChanges, SimpleChanges, Inject, OnDestroy } from '@angular/core';
import { DefaultFilter } from '@theme/components/grid/ng2-smart-table/components/filter/filter-types/default-filter';
import { FormControl } from '@angular/forms';
import { distinctUntilChanged, debounceTime } from 'rxjs/operators';
import  moment from 'moment';
import { Subscription } from 'rxjs';
import { DATE_SERVICE_INTERFACE, IDateService } from '@app/@core/services/interfaces/i-date-service.inteface';
import { AppConstant } from '@app/@core/constants/app-constant';
import { Moment } from 'moment';

@Component({
    templateUrl: './date-picker-filter.component.html',
    styleUrls: ['./date-picker-filter.component.scss'],
    standalone: false
})
export class DatePickerFilterComponent extends DefaultFilter
  implements OnInit, OnChanges, OnDestroy {
  inputControl = new FormControl();
  dateFormat: string;
  subscriptions: Array<Subscription> = [];
  oldQuery: string = null;


  constructor(@Inject(DATE_SERVICE_INTERFACE) private dateService: IDateService) {
    super();
    this.subscriptions.push(
      this.dateService.getDateFormat().subscribe(value => {
        this.dateFormat = value;
        this.inputControl.setValue(this.inputControl.value);
      })
    );
  }

  ngOnInit() {
    this.inputControl.valueChanges
      .pipe(distinctUntilChanged(), debounceTime(this.delay))
      .subscribe((value: Moment) => {
        if (moment(value).isValid()) {
          this.query =
            value !== null ? value.format(AppConstant.ServerDateFormat) : null;
        } else {
          this.query = null;
        }
        
        if (this.oldQuery != this.query) {
          this.setFilter();
        }
        this.oldQuery = this.query;
      });
  }

  ngOnChanges(changes: SimpleChanges) {
    if (changes.query) {
      this.query = changes.query.currentValue;
      const inputDate = moment(this.query, AppConstant.ServerDateFormat);
      if (!changes.query.firstChange && this.query != null) {
        this.inputControl.setValue(inputDate);
      }
    }
  }

  ngOnDestroy() {
    this.subscriptions.forEach(sub => sub.unsubscribe());
  }
}
